<script>
import { redirectToUConnect } from "../../helpers/routerHelper";
import router from "../../router";

export default {
  name: "connectingProperties",
  data() {
    return {
    };
  },
  methods: {
    redirectToUConnect,
    joinUConnect() {

      router.push({ path: "/pricing" });
    }
  }
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #ffffff">
    <el-col :span="24">
      <el-row style="padding: 0 16px">
        <el-col :span="24" style="display: flex; flex-direction: row">
          <span class="u-connect-p"
            >UNIFI: Linking Professionals, Unlocking Opportunities</span
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          style="display: flex; justify-content: center; padding: 10px 16px"
        >
          <el-button
            class="u-connect-btn"
            type="primary"
            @click="joinUConnect()"
            >Join</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          style="display: flex; justify-content: center; padding: 10px 16px"
        >
          <el-button
            class="u-connect-btn"
            type="primary"
            @click="redirectToUConnect"
          >Sign In</el-button
          >
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="24" class="flex-centered">
      <img
        class="image-u-connect"
        loading="lazy"
        src="../../assets/three.jpeg"
      />
    </el-col>
  </el-row>
</template>

<style scoped>
.u-connect-p {
  color: #003333;
  font: 400 25px DINosaur-a, sans-serif;
  display: flex;
}

.u-connect-btn {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  font: 500 14px DINosaur-a, sans-serif;
  border-radius: 5px;
}

.flex-centered {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 30px;
}

.image-u-connect {
  width: 100%;
  height: 200px;
  padding: 0 15px;
  object-fit: cover;
}

@media only screen and (max-width: 375px) {
  .image-u-connect {
    width: 100%;
    height: 150px;
    padding: 0 15px;
    object-fit: cover;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
  .image-u-connect {
    width: 100%;
    height: 400px;
    padding: 0 15px;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/connectingProperties.vue